import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { navigateToUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../../Config';
import attentionIcon from '../../images/attention-icon.svg';
import { goToPage } from '../../SpeedTestAndDisconnectionsWizardBlockSlice';
import { restartDevice } from '../../SpeedTestAndDisconnectionsWizardBlockThunk';

const RedirectManualInitializationPage = (props) => {

function onclickBtn(){
    navigateToUrl(props.genericWizardManualBlock);
}

  return (
      <div className='redirect-manual-initialization-page'>
        <div className='content-wrapper'>
        {props.manualInitializationPage.image && <Image className='icon' src={Config.epiBaseUrl + props.manualInitializationPage.image} alt={'attention image'} /> }
        {props.manualInitializationPage.title && <h1 className='title'>{props.manualInitializationPage.title}</h1>}
        {props.manualInitializationPage.subTitle && <h1 className='sub-title'>{props.manualInitializationPage.subTitle}</h1>}
        {props.manualInitializationPage.attentionText && <div className='attention-text-wrapper'><Image src={attentionIcon} alt='attention icon' /><div className='text'>{props.manualInitializationPage.attentionText}</div></div> }
        </div>
        <div className='buttons-wrapper'>
            {props.manualInitializationPage.buttonText && (
            <BtnSubmit text={props.manualInitializationPage.buttonText} onclick={() => onclickBtn()} formid={'automatic-router-initialization-page'} />
            )}
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    manualInitializationPage: state.speedTestAndDisconnectionsWizardBlock.epiBlockData.manualInitializationPage,
    genericWizardManualBlock: state.speedTestAndDisconnectionsWizardBlock.epiBlockData.genericWizardManualBlock,
  };
};

const mapDispatchToProps = {goToPage, restartDevice};

export default connect(mapStateToProps, mapDispatchToProps)(RedirectManualInitializationPage);
